import { render, staticRenderFns } from "./PreFooter.vue?vue&type=template&id=740eb8a6"
import script from "./PreFooter.vue?vue&type=script&lang=js"
export * from "./PreFooter.vue?vue&type=script&lang=js"
import style0 from "./PreFooter.vue?vue&type=style&index=0&id=740eb8a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports